// DeleteManualPassageRequest.
//
// Class representing a request to delete a manual passage for the specified PigRun.PigRunId value.
export class DeleteManualPassageRequest {
  public passageTimeStamp: Date;
  public pigRunId: number;

  public constructor(pigRunId: number, passageTimeStamp: Date) {
    this.pigRunId = pigRunId;
    this.passageTimeStamp = passageTimeStamp;
  }
}
